angular.module('natgeo').controller('Level2PostBuildScreen', ['$scope', '$element', 'ScreenFactory', 'screenManager', 'container', 'ColorizeFactory', 'UserProgress', 'CommonFunctions', 'ScreenView', 'SoundEngine',
function Level2PostBuildScreen($scope, element, ScreenFactory, manager, container, ColorizeFactory, UserProgress, CommonFunctions, ScreenView, SoundEngine)
{
	var screen = ScreenFactory( 'level2_post_build', element );
	
	// Initialize colorizing!
	screen.on('introBegin', function()
	{
		if ( !screen.body )
		{
			screen.body = ColorizeFactory( screen._bodyNoLabel );
			screen.bodySensor = ColorizeFactory( screen._bodySensor );

			screen.frontWheel = ColorizeFactory( screen._frontWheel );
			screen.backWheel = ColorizeFactory( screen._backWheel );
			screen.hiddenWheel = ColorizeFactory( screen._hiddenWheel );	
		}

		UserProgress.BodyColor = 0;
		UserProgress.WheelColor = 0;
		UserProgress.savePasscode();

		$scope.bodyColor( UserProgress.CurrentBodyColorName() );
		$scope.wheelColor( UserProgress.CurrentWheelColorName() );

		// Play the assembly, door, & moving sounds!
		SoundEngine.play( 'conveyor-belt', {
			delay: 0,
			duration: 4000
		});
		SoundEngine.play( 'assembly', {
			delay: 5000
		});
		SoundEngine.play( 'door', {
			delay: 3000
		});
		SoundEngine.play( 'door', {
			delay: 8500
		});
		SoundEngine.play( 'robot-move', {
			delay: 9500,
			loop: 1
		});
	});

	// No sounds
	screen.on( 'outroBegin', SoundEngine.stopAll );

	// When the screen is first loaded by the manager.
	screen.once('introBefore', function()
	{

		anim8.save('buildingDoorIntro', {
			keyframe: {
				'0,100': {
					scale: 1,
					translate: 0
				},
				'20,80': {
					scale: 1,
					translate: {x:-96, y:-24} 
				}
			},
			units: {
				translate: '%'
			}
		});

		anim8.save('windowFlashIntro', {
			keyframe: {
				'0,20,35,45,55,65,80,95,105,115,125,140' : {
					opacity: 0
				},
				'10,25,40,50,60,70,85,100,110,120,130': {
					opacity: 1
				}
			},
		});

		anim8.save('robotAssembledIntro', {
			keyframe: {
				from: {
					scale: 0.3,
					translate: {x: 180, y: -50}
				},
				to: {
					scale: 1,
					translate: 0
				}
			},
			units: {
				translate: '%'
			}
		}, {
			easing: 'linear'
		});

		anim8.save('buildBatteryConveyor', {
			keyframe: {
				'0': {
					scale: 1.0,
					translate: {x: -15, y: -10},
					opacity: 0
				},
				'1': {
					opacity: 1
				},
				'50': {
					scale: 1.1,
					translate: {x: 150, y: 100}
				},
				'100': {
					scale: 1.2,
					translate: {x: 320, y: 150}
				}
			},
			units: {
				translate: '%'
			}
		}, {
			duration: 2000,
			easing: 'linear'
		});

	});
	
	// Method invoked when user selects a color for the body.
	$scope.bodyColor = function(colorName)
	{
		screen.view.find( '.selectable.color.' + colorName ).play( 'rubberBand' );
		
		// Update user progress with selected body color
		UserProgress.BodyColor = UserProgress.GetBodyColor( colorName );
		UserProgress.savePasscode();

		var color = UserProgress.CurrentBodyColor();

		screen.body.setColor( UserProgress.Colors.Gray, color );
		screen.bodySensor.setColor( UserProgress.Colors.Gray, color );
	};
	
	// Method invoked when user selects a color for the wheels.
	$scope.wheelColor = function(colorName)
	{
		screen.view.find( '.selectable.color.' + colorName ).play( 'rubberBand' );
		
		// Update user progress with selected wheel color
		UserProgress.WheelColor = UserProgress.GetWheelColor( colorName );
		UserProgress.savePasscode();

		var color = UserProgress.CurrentWheelColor();

		screen.frontWheel.setColor( UserProgress.Colors.White, color );
		screen.backWheel.setColor( UserProgress.Colors.White, color );
		screen.hiddenWheel.setColor( UserProgress.Colors.White, color );
	};
	
	// The next screen is the test screen
	$scope.next = function()
	{
		manager.transition('level2_test');
	};

	// Test!
	$scope.begin = function()
	{
		manager.transition('level2_test');	
	};
	
	// The previous screen is the plan screen
	$scope.prev = function()
	{
		manager.transition('level2_conveyor');
	};
	
}]);